import { PostItem } from '../../../../entities/build/src/Content';
import PostItemService from './../../Axios/services/postItem.service';

export const GET_POSTS = 'GET_POSTS';
export const GET_POST = 'GET_POST';


//We don't need this function
export const getPosts = () => {
    return async (dispatch: any) => {
        try {
            let posts;
            await new Promise((res, rej) => {
                setTimeout(() => {
                    res('')
                }, 1000)
            })
            // const res = await PostItemService.getAll();
            // posts = res;
            dispatch({ type: GET_POSTS, value: posts })
        } catch (err: any) {
        }
    }
}

export const getPost = (id: string, posts: PostItem[]) => {
    return async (dispatch: any) => {
        try {
            dispatch({ type: GET_POST, value: undefined })
            let post;
            const res = await PostItemService.get(id, posts);
            post = res;
            dispatch({ type: GET_POST, value: post })
        } catch (err) {

        }
    }
}